export const preheaderMaxLength = 90
export const quillGuardCharacter = String.fromCodePoint(0xfeff)
export const quillTextChangeEvent = 'text-change'
export const quillSilentSource = 'silent'
export const quillUserSource = 'user'
